// E.g: Deaf/Hearing Impaired => deaf-hearing-impaired
export default (str, separator = '-') => {
  if (!str) return '';

  return str.replace(/[^\da-zA-Z]/g, separator).toLowerCase();
};
